import services from '.'
import { CreateReturnData, IData, ILesson, INewLesson } from '../@types'
import { getAxiosErrorMessage } from '../resources'

const baseURL = '/lessons'

interface LessonCreateReturnData {
  id: string
  videoUploadURL: string
  thumbnailUploadURL: string
}

async function getAll(): Promise<Array<ILesson> | undefined> {
  try {
    const lessons = await services.api
      .get<IData<Array<ILesson>>>(baseURL)
      .then(({ data }) => data?.data)

    return lessons
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByLevel(level: number): Promise<Array<ILesson> | undefined> {
  try {
    const uri = `${baseURL}?level=${level}`
    const { data } = await services.api.get<IData<Array<ILesson>>>(uri)
    return data?.data
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByID(id?: string): Promise<ILesson | undefined> {
  if (!id) return
  try {
    const lessons = await services.api
      .get<IData<Array<ILesson>>>(`${baseURL}?id=${id}`)
      .then(({ data }) => data?.data)

    return lessons && lessons[0]
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function getByModuleID(
  moduleId?: string,
): Promise<Array<ILesson> | undefined> {
  if (!moduleId) return
  try {
    const lessons = await services.api
      .get<IData<Array<ILesson>>>(`${baseURL}?moduleId=${moduleId}`)
      .then(({ data }) => data?.data)

    return lessons
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function create({
  title,
  video,
  moduleId,
  position,
  description,
  thumbnail,
}: INewLesson): Promise<CreateReturnData | undefined> {
  try {
    const { data } = await services.api.post<IData<LessonCreateReturnData>>(
      baseURL,
      {
        description,
        moduleId,
        title,
        thumbnail,
        video,
        position,
      },
    )

    console.log({ data })

    if (!data?.data) throw new Error('no data returned from server')

    return {
      id: data?.data.id,
      videoUploadURL: data?.data.videoUploadURL,
      thumbnailUploadURL: data?.data.thumbnailUploadURL,
    }
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function deleteById(id: string): Promise<void> {
  try {
    await services.api.delete(`${baseURL}/${id}`)
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function saveLog(id: string): Promise<void> {
  try {
    await services.api.post(`${baseURL}/logs`, { id })
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

async function updateById(
  id: string,
  data: Partial<INewLesson>,
): Promise<CreateReturnData | undefined> {
  try {
    const updated = await services.api
      .put<IData<LessonCreateReturnData>>(baseURL, { id, ...data })
      .then(({ data }) => data?.data)

    if (!updated) throw new Error('no data returned from server')

    return {
      id: updated.id,
      videoUploadURL: updated.videoUploadURL,
      thumbnailUploadURL: updated.thumbnailUploadURL,
    }
  } catch (error) {
    throw new Error(getAxiosErrorMessage(error))
  }
}

export default {
  getAll,
  create,
  getByID,
  deleteById,
  saveLog,
  updateById,
  getByModuleID,
  getByLevel,
}
